<template>

<div>
  <PageTitle :route="$route">
    <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        v-on:click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <CompanyList />
    </div>
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import CompanyList from '@/components/settings/users/company/CompanyList'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'Company',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    CompanyList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addcompany' })
    }
  }
}
</script>
